import { Component, OnInit, Injector, inject } from '@angular/core';
import { apiSuccessfulPasswordResetType, LoginCoreComponent } from './loginCore.component';
import { AppConfig } from "app/app.config";
import { authUserType, reRgType } from "app/services/auth.service";
import { FormGroup, FormsModule } from "@angular/forms";
import { ContinueOnModalComponent } from "app/components/Controls/continue-on/continue-on.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { RouterLink } from '@angular/router';
import { CapsLockComponent } from '../../components/Controls/caps-lock/caps-lock.component';
import { NWMTfaComponent } from '../../components/Controls/tfa/tfa.component';
import { NgTemplateOutlet, NgClass } from '@angular/common';
import { EqualValidator } from '../../components/Controls/equal-validator.directive';
import { AwardsComponent } from '../../components/Controls/awards/awards.component';

@Component({
    templateUrl: './login-help.component.html',
    styleUrls: ['./login-help.component.scss'],
    imports: [RouterLink, FormsModule, CapsLockComponent, NWMTfaComponent, NgTemplateOutlet, EqualValidator, AwardsComponent, NgClass]
})
// go to /account/resetpassword/test_reset to test reset screen
// go to /account/resetpassword/test_new to test registration screen
export class LoginHelpComponent extends LoginCoreComponent implements OnInit {
  override config = inject(AppConfig);
  private modalService = inject(NgbModal);


  public helpType = '';
  public path = ''; // forgotpassword, forgotusername, resetpassword, registration
  public resetPassword?: apiSuccessfulPasswordResetType;
  public user?: authUserType;
  public reRg?: reRgType;
  public passwordErrorMessage = '';
  public confirmPassword = '';
  public confirmPasswordErrorMessage = '';
  public passwordFormSubmitted = false;
  public code = '';
  public resetCode = '';

  public isRegistration = false;

  public showScreen = 'LoginHelp';//ForgotUserName, UserName, Disclaimer, IdQuestion, ForgotPassword, PasswordForm, Registration, ResetPassword

  constructor() {
    const injector = inject<Injector>(Injector);

    super(injector);
  }

  ngOnInit() {

    if (this.config.demoSite) { // disable this functionality on Demo Site
      this.router.navigate(['/error/client/2']);
      return false;
    }

    this.user = undefined;
    this.resetPassword = undefined;
    this.path = this.route.snapshot.url[0].path;

    if (this.path == 'passwordreset') this.path = 'forgotpassword';
    if (this.path == 'forgotpassword') this.showScreen = 'ForgotPassword';
    if (this.path == 'forgotusername') this.showScreen = 'ForgotUserName';

    if (this.path == 'resetpassword') { // link names are confusing ...
      this.code = this.route.snapshot.params['code'];
      if (this.code && this.code.length) {
        this.post(this.config.resetPassword.verifyCodeUrl, { 'code': this.code },
          data => {
            if (Object.prototype.hasOwnProperty.call(data, 'DisplayName')) {
              this.resetPassword = data as apiSuccessfulPasswordResetType;
              this.isRegistration = parseInt(this.resetPassword.EmailType) > 1; //PasswordOnly = 0, PasswordWithSecurityQuestions = 1, PasswordWithSecurityQuestionsNewUser = 2, PasswordOnlyNewUser = 3, None=4
              this.showScreen = this.isRegistration ? 'Registration' : 'ResetPassword';
            }
            else {
              this.router.navigate(['/error/client/2']); //Invalid or expired link.
            }
          },
          () => {
            this.router.navigate(['/error/client/2']); //Invalid or expired link.
          }
        );
      }
    }
    this.openContinueOnModal = (url) => {
      const modalRef = this.modalService.open(ContinueOnModalComponent,{ centered: true });
      modalRef.componentInstance.setUrlTo(url);
      this.loaderService.display(false,'login');
    };
    return true;
  }

  setUser(user: authUserType) {
    this.user = {
      ...user,
      isClient: !user.roles || user.roles.length == 0 || user.roles.indexOf('Client') > -1,
      isAccountant: user.roles && user.roles.indexOf('Accountant') > -1
    };
    this.reRg = this.user?.reRgs?.find(f=>f.IsDefault);
  }

  setHelpType() {
    this.router.navigate(['/account/' + this.helpType]);
  }

  submit() {
    type bodyType = {
      email: string;
      password?: string;
      username?: string;
    };
    this.errorMsg = '';
    const body: bodyType = { email: this.email };
    if (this.showScreen === 'ForgotUserName') {
      body.password = this.password;
    } else if (this.showScreen === 'ForgotPassword') {
      body.username = this.username;
    }
    this.post(this.config.forgotPassword.getTFAProviders, body); // see LoginCoreComponent.post for details - everythig's processed there
  }

  override tfaPassed(user: authUserType) {
    this.sentcode=false;
    this.username = user.userName; // need for ForgotUserName and ResetPassword
    this.setUser(user);
    if (this.isRegistration) {
      this.showScreen='Disclaimer';
      this.resetCode = user.reset_token as string;
    } else if (this.showScreen=='ForgotUserName') {
      this.showScreen = 'UserName';
    } else if (this.showScreen=='ForgotPassword' || this.showScreen=='ResetPassword') {
      this.showScreen = 'PasswordForm';
      this.resetCode = user.reset_token as string;
    }
  }

  override tfaTimeOut() {
    if (this.code == 'test_new' || this.code == 'test_reset') {
      if (this.showScreen == 'Registration') {
        this.showScreen = 'Disclaimer';
      }
    } else {
      super.tfaTimeOut();
    }
  }

  acceptDisclaimer() {
    if (!this.user!.isAccountant)
      localStorage.setItem('FirstLogin', 'true');
    this.showScreen = 'PasswordForm';
  }

  declineDisclaimer() {
    window.location.href = 'https://www.nicolawealth.com';
  }

  submitPassword() {
    this.passwordFormSubmitted = true;
    const body = {'Username': this.username, 'Code': this.resetCode, 'Password': this.password, 'ConfirmPassword': this.confirmPassword};
    this.post(this.config.resetPassword.passwordResetUrl, body); //LoginCoreComponent.post takes care of authorizing and redirecting user
  }

  validatePasswords(form: FormGroup){
    if(form.dirty && !form.valid) {
      if(form.controls?.['password']?.errors?.['required']){
          this.passwordErrorMessage='*Password is required.';
          return false;
      }
      if(form.controls?.['password']?.errors?.['minlength']){
          this.passwordErrorMessage='*Password must contain at least 12 characters.';
          return false;
      }
      if(form.controls?.['confirmPassword']?.errors?.['validateEqual']){
          this.passwordErrorMessage='*Passwords do not match.';
          return false;
      }
    }
    this.passwordErrorMessage='';
    return true;
  }
}
